import React from "react";
import { Platform, ScrollView } from "react-native";
import { Box, TouchableBox } from "./AHTheme/Box";
import { useLayoutContext } from "./LayoutProvider";
import { AHText, AHTextFonts } from "./Text/AHText";

export function TopTab(props: {
  children: React.ReactNode;
  isCompact: boolean;
}) {
  const layout = useLayoutContext();
  const borderWidth = 1;
  const height = layout.circle.medium + layout.space.small + borderWidth * 2;
  const paddingHorizontal = layout.space.small + layout.space.xsmall;
  const paddingBottom = layout.space.small;

  if (Platform.OS === "web" || !props.isCompact) {
    return (
      <Box
        style={[
          {
            flexDirection: "row",
            alignItems: "center",
            height,
            paddingHorizontal,
            paddingBottom,
          },
        ]}
        color="surface-primary"
      >
        {props.children}
      </Box>
    );
  }
  return (
    <Box style={{ height }} color="surface-primary">
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={{
          paddingHorizontal,
          paddingBottom,
        }}
      >
        {props.children}
      </ScrollView>
    </Box>
  );
}

export function TopTabItem(props: {
  children: React.ReactNode;
  selected?: boolean;
  onPress: () => void;
  detail?: React.ReactNode;
}) {
  const layout = useLayoutContext();

  return (
    <TouchableBox spaceHorizontal="xsmall" onPress={props.onPress}>
      <Box
        spaceHorizontal="small"
        color={props.selected ? "darkerText" : "surface"}
        borderColor={props.selected ? "darkerText" : "border-primary"}
        style={{
          borderWidth: 1,
          flexDirection: "row",
          alignItems: "center",
          height: layout.circle.medium,
          borderRadius: 100,
        }}
      >
        <AHText
          selectable={false}
          type="title-small"
          spaceHorizontal="xsmall"
          color={props.selected ? "text-inverted" : "text-washed"}
        >
          {props.children}
        </AHText>
        {props.detail ? (
          <AHText
            selectable={false}
            type="title-small"
            spaceHorizontal="xsmall"
            font={AHTextFonts.REGULAR}
            color={props.selected ? "text-inverted" : "text-washed"}
          >
            {props.detail}
          </AHText>
        ) : null}
      </Box>
    </TouchableBox>
  );
}
